import { render, staticRenderFns } from "./OtherFiles.vue?vue&type=template&id=4c7cc11c&scoped=true"
import script from "./OtherFiles.vue?vue&type=script&lang=js"
export * from "./OtherFiles.vue?vue&type=script&lang=js"
import style0 from "./OtherFiles.vue?vue&type=style&index=0&id=4c7cc11c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7cc11c",
  null
  
)

export default component.exports